import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'pay_and_benefits'

export const dataPointDefinition = {
  retracedId: 'pay_and_benefits',
  name: 'Pay and benefits',
  description: 'Include, e.g., grievances related to wages, benefits, bonus.',
  meta: {
    slcpMeta: {
      key: 'wi-gri-19',
      number: 'WI-GRI-14',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'wi-gri-19', version: '1.7.0', provider: 'slcp'}],
  sortingId: 36670,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
